export enum ActionTypes {
  CHANGE_LANGUAGE = 'CHANGE_LANGUAGE',
  CHANGE_THEME = 'CHANGE_THEME'
}
